import React, { Component, forwardRef } from "react";
import axios from "axios";
import numeral from "numeral";
import { awsUrl2, awsUrl } from "../../config";
import Clamp from "react-multiline-clamp";
import moment from "moment";
import MaterialTable from "material-table";
// import MaterialReactTable from "material-react-table";

import { TablePagination } from "@mui/material";
import ArrowDownward from "@mui/icons-material/ArrowDownward";
import Search from "@mui/icons-material/Search";
import Clear from "@mui/icons-material/Clear";
import FirstPage from "@mui/icons-material/FirstPage";
import LastPage from "@mui/icons-material/LastPage";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import ChevronRight from "@mui/icons-material/ChevronRight";
import Check from "@mui/icons-material/Check";
import Loader from "../common/Loader";
import { Nav } from "react-bootstrap";
import Header from "../common/Header";
import { Auth } from "aws-amplify";
import SideTab from "../../newcomponent/common/SideTab";
import ToggleSwitch from "../../utils/ToggleSwitch";
import Popup from "../common/Popup";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import toast, { Toaster } from "react-hot-toast";
import {
  saveInUserstatusTable,
  saveInUserTable,
} from "../../utils/form_compPro";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import { alpha } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { setCommentBoxColor } from "../../utils/common";
import { RotatingLines } from "react-loader-spinner";
import SaveAlt from "@mui/icons-material/SaveAlt";
import parse from "html-react-parser";
import { Modal } from "react-bootstrap";
import { DownloadDashboardFiles } from "../subcompo/DownloadDashboardFiles";
import {
  createCommentForDownload,
  createSubmissionForDownload,
} from "../common/dashboard_helper";
import "./DashboardLibertate.scss";
import carrierList from "../../utils/carrierList.json";
const { carrierMapping } = carrierList;

const { convertMaterialColumnsToMaterialReactTable } = require("./util");

import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
} from "@mui/material";

import { GlobalAuthContext } from "../../context/AuthProvider";

let ismobile_font = window.innerWidth < 1600;
const tableIcons = {
  SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  // Filter: forwardRef((props,ref) => <Filter {...props} ref={ref} />)
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: () => <></>,
};

let isMobile_sidenav = window.innerWidth < 900;
class DashboardLibertate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: "tab1",
      modalBody: [],
      openModal: false,
      agentButton: false,
    };
  }

  static contextType = GlobalAuthContext;

  setSelected = (tab) => {
    let selected = this.state.state;
    if (selected !== tab) {
      this.setState({ selected: tab });
    }
  };

  handleAgentCommentsButtonClick = (comments, submittedDate) => {
    this.setState({ agentButton: true });
    if (typeof comments[0] === "string" && comments[0] !== "") {
      let updatedComment = [
        {
          ...initialcomment,
          comment: comments[0],
          commentTimestamp: submittedDate,
        },
      ];
      this.setState({ modalBody: updatedComment });
    } else if (typeof comments[0] === "object") {
      this.setState({ modalBody: comments });
    } else {
      this.setState({ modalBody: [initialcomment] });
    }

    this.setState({ openModal: true });
  };

  handleUwCommentHistory = (rowdata, rowkey) => {
    this.setState({ agentButton: false });
    rowdata.forEach((item) => {
      if (item.user_email_id === rowkey) {
        if (typeof item.uw_comments?.[0] === "object") {
          this.setState({ modalBody: item.uw_comments });
        } else if (typeof item.agent_comments?.[0] === "string") {
          let updatedComment = [
            {
              ...initialcomment,
              comment: item.uw_comments[0],
              commentTimestamp: item.uploadTimestamp,
            },
          ];
          this.setState({ modalBody: updatedComment });
        }
      }
    });
    this.setState({ openModal: true });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };

  render() {
    let { selected, modalBody, openModal, agentButton } = this.state;

    const { user, allowedGroups } = this.context;

    const tabsMap = {
      tab1: "User Dashboard",
    };

    return (
      <div className="dashboard-container">
        <div
          className="d-flex bg-light"
          style={{ borderBottomStyle: "groove" }}
        >
          <Header />
        </div>

        <div className="position-relative">
          {isMobile_sidenav ? <SideTab /> : " "}

          <div className="tabs  lib_dashboard">
            <div className="d-flex justify-content-center mb-3 text-center">
              <h2 className="mt-3 mb-3">
                <b>Dashboard</b>
              </h2>
            </div>
            <Nav
              className="userdashboard__button"
              variant="pills"
              defaultActiveKey={selected}
              style={{ fontSize: "16px" }}
            >
              {Object.keys(tabsMap).map((tab) => (
                <Nav.Item>
                  <Nav.Link
                    eventKey={tab}
                    onClick={() => this.setSelected(tab)}
                  >
                    {tabsMap[tab]}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
            {Object.keys(tabsMap).map((tab) => (
              <div key={tab} className="Admin__Dashboard">
                {
                  <LibertateDashboard
                    tabName={tab}
                    selected={selected}
                    modalBody={modalBody}
                    openModal={openModal}
                    agentButton={agentButton}
                    handleAgentCommentsButtonClick={
                      this.handleAgentCommentsButtonClick
                    }
                    handleUwCommentHistory={this.handleUwCommentHistory}
                    handleCloseModal={this.handleCloseModal}
                    user={user}
                    allowedGroups={allowedGroups}
                  />
                }
              </div>
            ))}
          </div>
        </div>
        <Loader />
      </div>
    );
  }
}

class TextField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
      loggedInEmail: "",
    };
  }
  onChangeHandler(target) {
    this.setState({ value: target });
  }

  componentDidMount() {
    this.loggedInEmailId();
  }

  loggedInEmailId = async () => {
    try {
      let sessionData = this.props.user;
      console.log("++sd", sessionData);
      this.setState({ loggedInEmail: sessionData["attributes"]["email"] });
    } catch (error) {
      console.error("Error fetching authenticated user:", error);
    }
  };

  render() {
    let { value, loggedInEmail } = this.state;
    return (
      <textarea
        value={value}
        className="underwriter_comment"
        rows="1"
        style={{
          width: "100%",
          backgroundColor: setCommentBoxColor(this.props.comments),
        }}
        onChange={(e) => this.onChangeHandler(e.target.value)}
        onBlur={(e) => {
          let agentCommentsCopy = this.props.agentCommentsHistory;

          let currentTimestamp = moment().valueOf();
          let dataToSave = {};

          if (agentCommentsCopy === undefined && e.target.value.trim() !== "") {
            agentCommentsCopy = [
              {
                comment: e.target.value.trim(),
                commentTimestamp: currentTimestamp,
                email: loggedInEmail,
              },
            ];
          } else if (
            e.target.value.length === 0 ||
            e.target.value.trim() === ""
          ) {
            if (
              agentCommentsCopy[0]?.comment &&
              e.target.value.trim() !== agentCommentsCopy[0]?.comment
            ) {
              agentCommentsCopy.unshift({
                comment: e.target.value.trim(),
                commentTimestamp: currentTimestamp,
                previousComment: "true",
                email: loggedInEmail,
              });
            } else if (
              agentCommentsCopy[0] &&
              typeof agentCommentsCopy[0] === "string"
            ) {
              e.target.value.trim() !== agentCommentsCopy[0] &&
                agentCommentsCopy.unshift({
                  comment: e.target.value.trim(),
                  commentTimestamp: currentTimestamp,
                  previousComment: "true",
                  email: loggedInEmail,
                });
            } else {
              console.log("I m returning as value is 0");
              return;
            }
          } else if (typeof agentCommentsCopy[0] === "string") {
            e.target.value.trim() !== agentCommentsCopy[0] &&
              agentCommentsCopy.unshift({
                comment: e.target.value.trim(),
                commentTimestamp: currentTimestamp,
                email: loggedInEmail,
              });
          } else {
            e.target.value.trim() !== agentCommentsCopy[0]?.comment &&
              agentCommentsCopy.unshift({
                comment: e.target.value.trim(),
                commentTimestamp: currentTimestamp,
                email: loggedInEmail,
              });
          }

          this.props.handleAgentCommentHistory(
            this.props.rowData,
            agentCommentsCopy,
          );
          dataToSave.user_email_id = this.props.rowData.user_email_id;
          dataToSave.sortKeyList = this.props.rowData.uuidCarriers;
          dataToSave.agent_comments = agentCommentsCopy;
          dataToSave.agent_comments && this.props.callback(dataToSave);
        }}
      ></textarea>
    );
  }
}

let initialcomment = {
  comment: "",
  commentTimestamp: "",
  email: "",
};
class LibertateDashboard extends Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef();
    this.state = {
      isLoading: true,
      scrollLeft: false,
      scrollRight: true,
      submissionYesNoList: {},
      agentCommentsHistory: {},
      popupData: {
        title: "",
        children: <></>,
        acceptBtn: "",
        acceptBtnCallback: () => {},
        rejectBtnCallback: () => {},
        show: false,
      },
      loggedInGroups: [],
      dataLoading: true,
      populateFlag: false,
      modalData: {},
    };
  }

  componentDidMount = () => {
    let isSwitchUser = sessionStorage.getItem("isSwitchUser");
    let currentUser = sessionStorage.getItem("currentUser");

    sessionStorage.clear();

    if (isSwitchUser === "true") {
      sessionStorage.setItem("currentUser", currentUser);
      sessionStorage.setItem("isSwitchUser", "true");
    }
    this.updateDisplay();
  };

  camelCase = (str) => {
    if (!str) return "";
    return str
      .trim()
      .split(" ")
      .map((word) => {
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
      })
      .join(" ");
  };

  onClickCompanyName = (rowData) => {
    let isSwitchUser = sessionStorage.getItem("isSwitchUser");
    let currentUser = sessionStorage.getItem("currentUser");

    sessionStorage.clear();

    if (isSwitchUser === "true") {
      sessionStorage.setItem("currentUser", currentUser);
      sessionStorage.setItem("isSwitchUser", "true");
    }

    if (rowData.amtrustAccountDetails) {
      sessionStorage.setItem(
        "amtrustAccountDetails",
        JSON.stringify(rowData.amtrustAccountDetails),
      );
    }
    if (rowData.amtrustAccountDetailsCopy) {
      sessionStorage.setItem(
        "amtrustAccountDetailsCopy",
        JSON.stringify(rowData.amtrustAccountDetailsCopy),
      );
    }

    let currProspect = {
      childrenLoc: rowData.childrenLoc,
      companyProfile: rowData.companyProfile,
      emodStatesData: rowData.emodStatesData,
      riskProfile: rowData.riskProfile,
      peoDetails: rowData.peoDetails,
      carrierList: rowData.carrierList,
      riskProfileId: rowData.riskProfileId,
      targetPremium: rowData.targetPremium,
      questcoId: rowData.questcoId,
      historicalClaims: rowData.historicalClaims,
    };

    if (rowData.uw_ques) {
      currProspect["uwQues"] = rowData.uw_ques;
    }

    if (rowData.salesforceData) {
      sessionStorage.setItem(
        "salesforceData",
        JSON.stringify(rowData.salesforceData),
      );
    }

    if (rowData.status === "quote_generated") {
      sessionStorage.setItem("quoteData", JSON.stringify(rowData.quoteData));
      sessionStorage.setItem("address", JSON.stringify(rowData.address));
      sessionStorage.setItem("formStage", "three");
      if (rowData.quoteSubmitted) {
        sessionStorage.setItem("hideButtons", "true");
      }
    } else if (rowData.status === "company_profile") {
      sessionStorage.setItem("formStage", "two");
    } else {
      sessionStorage.setItem("formStage", "one");
    }

    sessionStorage.setItem("currProspect", JSON.stringify(currProspect));
    sessionStorage.setItem("user_id", rowData.user_email_id);

    window.location.href = "/Quote";
  };

  updateData = (data) => {
    new Promise((resolve, reject) => {
      try {
        axios
          .post(awsUrl + "/api/underWriterData/update", data)
          .then((res) => {
            console.log("data saved");
            resolve();
          })
          .catch((err) => {
            console.log("error while saving", err);
            reject();
          });
      } catch (error) {}
    });
  };

  updateDataInUser = (data) => {
    new Promise((resolve, reject) => {
      try {
        let data_req = JSON.parse(JSON.stringify(data));
        if (data_req.sortKeyList) {
          delete data_req.sortKeyList;
        }
        axios
          .post(awsUrl2 + "/api/userTableData/update", data_req)
          .then((res) => {
            console.log("data saved");
            resolve();
          })
          .catch((err) => {
            console.log("error while saving", err);
            reject();
          });
      } catch (error) {}
    });
  };

  dateSort = (a, b, field) => {
    let momentA = moment(a[field], "M/D/YY");
    let momentB = moment(b[field], "M/D/YY");

    if (
      (!momentA.isValid() && momentB.isValid()) ||
      momentA.isBefore(momentB)
    ) {
      return -1;
    } else if (
      (momentA.isValid() && !momentB.isValid()) ||
      momentA.isAfter(momentB)
    ) {
      return 1;
    } else {
      return 0;
    }
  };

  customFilterAll = (term, rowData, field) => {
    let customFieldName = field["field"];

    return rowData[customFieldName]
      ?.toString()
      ?.toLowerCase()
      ?.startsWith(term?.toLowerCase());
  };

  scrollLeft = () => {
    let { scrollLeft, scrollRight } = JSON.parse(JSON.stringify(this.state));
    const tableContainerDiv =
      this.myRef.current.lastChild.lastChild.children[2].children[0]
        .children[0];

    if (tableContainerDiv) {
      tableContainerDiv.scrollLeft -= 150;
      if (tableContainerDiv.scrollLeft == 0) {
        this.setState({ scrollLeft: false });
        this.setState({ scrollRight: true });
      }

      const maxScrollLeft =
        tableContainerDiv.scrollWidth - tableContainerDiv.clientWidth;

      if (tableContainerDiv.scrollLeft < maxScrollLeft) {
        this.setState({ scrollRight: true });
      }
    }
  };

  scrollRight = () => {
    let { scrollLeft, scrollRight } = JSON.parse(JSON.stringify(this.state));

    const tableContainerDiv =
      this.myRef.current.lastChild.lastChild.children[2].children[0]
        .children[0];

    if (tableContainerDiv) {
      tableContainerDiv.scrollLeft += 150;
      this.setState({ scrollLeft: true });
    }

    const maxScrollLeft =
      tableContainerDiv.scrollWidth - tableContainerDiv.clientWidth;

    if (tableContainerDiv.scrollLeft > maxScrollLeft) {
      this.setState({ scrollRight: false });
    }
  };

  fontfunciton = () => {
    if (window.innerWidth < 1600 && window.innerWidth > 1500) {
      return "0.84rem";
    }
    if (window.innerWidth < 1500 && window.innerWidth > 1410) {
      return "0.8rem";
    }
    if (window.innerWidth < 1410 && window.innerWidth > 1310) {
      return "0.76rem";
    }
    if (window.innerWidth < 1300) {
      return "0.72rem";
    }
  };

  customFilterAll = (term, rowData, field) => {
    let customFieldName = field["field"];

    return rowData[customFieldName]
      ?.toString()
      ?.toLowerCase()
      ?.startsWith(term?.toLowerCase());
  };

  formatFein = (value) => {
    if (!value) return "-";
    let fein = "-";
    value = value?.split("-")?.join("");
    var len = value?.length,
      dummystr = "000000000";

    if (len === 0) {
      fein = "-";
    } else if (len > 0 && len < 9) {
      value = dummystr.slice(0, 9 - len) + "" + value;
      fein = value[0] + value[1] + "-" + value?.slice(2);
    } else {
      fein = value[0] + value[1] + "-" + value?.slice(2);
    }

    return fein;
  };

  handleAgentCommentHistory = (rowData, data) => {
    this.setState((prevstate) => {
      let agentCommentsHistory = JSON.parse(
        JSON.stringify(prevstate.agentCommentsHistory),
      );
      agentCommentsHistory[rowData?.user_email_id] = data;
      return { agentCommentsHistory: agentCommentsHistory };
    });
  };

  toggleSwitchHandlerInDashboard = async (valueCheck, rowData) => {
    let value = valueCheck ? "false" : "true";
    let req_body_userstatus = {
      user_email_id: rowData?.user_email_id,
      real_submission: value,
      address: rowData?.address,
      timestamp: rowData?.quoteData?.date,
      uuid: rowData?.quoteData?.uuid,
      peo: rowData.peoDetails.selectedPeo,
    };
    let req_body_users = {
      user_email_id: rowData?.user_email_id,
      real_submission: value,
    };
    let result1 = saveInUserstatusTable(req_body_userstatus);
    let result2 = saveInUserTable(req_body_users);

    Promise.all([result1, result2])
      .then(([result1, result2]) => {})
      .catch((err) => {
        console.log(err);
      });

    this.setState((prevstate) => {
      let submissionYesNoList = JSON.parse(
        JSON.stringify(prevstate.submissionYesNoList),
      );
      submissionYesNoList[rowData?.user_email_id] = valueCheck ? false : true;
      return { submissionYesNoList: submissionYesNoList };
    });
  };

  selectedPeoFormat = (selectedPeo) => {
    let displayPEOName = selectedPeo?.toLowerCase();
    if (selectedPeo === "insurecomp") {
      displayPEOName = "LIB";
    } else if (selectedPeo === "esg halcyon") {
      displayPEOName = "ESG Halcyon";
    } else if (selectedPeo === "express hr" || selectedPeo === "expresshr") {
      displayPEOName = "Express HR";
    } else if (selectedPeo === "gregory") {
      displayPEOName = "J Gregory";
    } else if (selectedPeo === "totalsolution") {
      displayPEOName = "Total Solution";
    } else if (selectedPeo === "payrollmadeeasy") {
      displayPEOName = "Payroll Made Easy";
    } else if (selectedPeo === "stafflink") {
      displayPEOName = "Prestige";
    }
    displayPEOName = displayPEOName?.replace(/\b\w/g, (char) =>
      char?.toUpperCase(),
    );

    // Capitalize entire word if it's only 4 or less than 4 letters
    if (displayPEOName?.length <= 4) {
      displayPEOName = displayPEOName?.toUpperCase();
    }
    return displayPEOName;
  };

  setModalData = (data) => {
    this.setState({ modalData: data });
  };

  setTableData = () => {
    let {
      rowDataList,
      isLoading,
      scrollLeft,
      scrollRight,
      submissionYesNoList,
      agentCommentsHistory,
      loggedInGroups,
    } = JSON.parse(JSON.stringify(this.state));
    let {
      tabName,
      handleAgentCommentsButtonClick,
      handleUwCommentHistory,
      user,
    } = this.props;

    const isPeo = user?.attributes?.["custom:user_type"] === "peo";

    // Calculate total column width to ensure full coverage
    const totalColumns = this.calculateTotalColumns();

    let columns = {
      tab1: [
        {
          title: "Company Name",
          field: "companyName",
          filtering: true,
          filterPlaceholder: "Filter",
          cellStyle: {
            padding: "2px 0px 2px 12px",
            minWidth: "220px", // Slightly increased
            maxWidth: "450px",
            whiteSpace: "nowrap",
          },
          headerStyle: {
            padding: "0px 0px 0px 10px",
            minWidth: "220px",
            maxWidth: "450px",
          },
          filterCellStyle: {
            padding: "5px 0px 5px 4px",
          },
          render: (rowData) => (
            <Clamp lines={2}>
              <span>
                <div
                  onClick={() => this.onClickCompanyName(rowData)}
                  className="company-name"
                >
                  {this.camelCase(rowData.companyName)}
                </div>
              </span>
            </Clamp>
          ),
          customSort: (a, b) => {
            const nameA = a.companyName.toUpperCase().trim();
            const nameB = b.companyName.toUpperCase().trim();

            if (nameA < nameB) return -1;
            if (nameA > nameB) return 1;
            return 0;
          },
        },
        {
          title: "FEIN",
          field: "fein",
          filterPlaceholder: "Filter",
          customFilterAndSearch: (term, rowData, field) =>
            this.customFilterAll(term, rowData, field),
          cellStyle: {
            wordBreak: "break-all",
            padding: "2px 0px 2px 2px",
            minWidth: "110px", // Slightly increased
          },
          headerStyle: {
            padding: "10px 0",
            minWidth: "110px",
          },
          render: (rowData) => (
            <Clamp lines={1}>{this.formatFein(rowData?.fein) || ""}</Clamp>
          ),
        },
        {
          title: "Gov CC State",
          field: "govCCState",
          filtering: true,
          filterPlaceholder: "Filter",
          cellStyle: {
            padding: "2px 0px 2px 6px",
            minWidth: "130px", // Increased from 120px
            width: "auto",
          },
          headerStyle: {
            padding: "0px 0px 0px 10px",
            minWidth: "130px",
            width: "auto",
          },
          render: (rowData) => (
            <Clamp lines={1}>{rowData.govCCState || "-"}</Clamp>
          ),
        },
        {
          title: "Class Code",
          field: "govClassCode",
          filtering: true,
          filterPlaceholder: "Filter",
          cellStyle: {
            padding: "2px 0px 2px 6px",
            minWidth: "130px", // Increased from 120px
            width: "auto",
            textAlign: "center",
          },
          headerStyle: {
            padding: "0px 0px 0px 10px",
            minWidth: "130px",
            width: "auto",
            textAlign: "center",
          },
          render: (rowData) => (
            <Clamp lines={1}>{rowData.govClassCode || "-"}</Clamp>
          ),
          customSort: (a, b) => {
            const codeA = +a.govClassCode || 0;
            const codeB = +b.govClassCode || 0;
            return codeA - codeB;
          },
        },
        {
          title: "Payroll",
          field: "payroll",
          filtering: true,
          filterPlaceholder: "Filter",
          cellStyle: {
            padding: "2px 0px 2px 6px",
            minWidth: "140px", // Increased from 120px
            textAlign: "right",
          },
          headerStyle: {
            padding: "0px 0px 0px 5px",
            minWidth: "140px",
            textAlign: "center",
          },
          render: (rowData) => (
            <div className="payrollBox">
              <Clamp lines={1}>{rowData.payroll}</Clamp>
            </div>
          ),
          customSort: (a, b) => {
            const payrollA = numeral(a.payroll).value() || 0;
            const payrollB = numeral(b.payroll).value() || 0;
            return payrollA - payrollB;
          },
        },
        {
          title: "Effective Date",
          field: "effectiveDate",
          filtering: true,
          filterPlaceholder: "Filter",
          render: (rowData) => rowData.effectiveDate,
          customSort: (a, b) => this.dateSort(a, b, "effectiveDate"),
          headerStyle: {
            padding: "0px 0px 0px 8px",
            minWidth: "130px", // Increased from 120px
            textAlign: "center",
          },
          cellStyle: {
            padding: "2px 0px 2px 6px",
            minWidth: "130px",
            width: "auto",
            textAlign: "center",
          },
          customFilterAndSearch: (term, rowData, field) =>
            this.customFilterAll(term, rowData, field),
        },
        ...(!isPeo
          ? [
              {
                title: "Distributing Partners",
                field: "selectedPeoToDisplay",
                filtering: true,
                filterPlaceholder: "Filter",
                cellStyle: {
                  padding: "2px 0px 2px 6px",
                  minWidth: "100px", // Increased from 180px
                  textAlign: "left",
                },
                headerStyle: {
                  padding: "0px 0px 0px 10px",
                  minWidth: "100px",
                  textAlign: "left",
                },
                render: (rowData) => (
                  <Clamp lines={1}>{rowData.selectedPeoToDisplay || "-"}</Clamp>
                ),
              },
            ]
          : []),
        {
          title: "Modified By",
          field: "modifiedBy",
          filtering: true,
          filterPlaceholder: "Filter",
          render: (rowData) => (
            <Clamp lines={1}>
              {rowData.modifiedBy
                ? rowData.modifiedBy.split("@")[0].length <= 3
                  ? rowData.modifiedBy.split("@")[0].toUpperCase()
                  : rowData.modifiedBy.split("@")[0][0].toUpperCase() +
                    rowData.modifiedBy.split("@")[0].slice(1)
                : ""}
            </Clamp>
          ),
          headerStyle: {
            padding: "0px 0px 0px 10px",
            minWidth: "140px", // Increased from 120px
          },
          cellStyle: {
            padding: "2px 0px 2px 6px",
            minWidth: "140px",
            width: "auto",
          },
        },
        {
          title: "Status",
          field: "step",
          filtering: true,
          filterPlaceholder: "Filter",
          cellStyle: {
            padding: "2px 0px 2px 6px",
            minWidth: "140px", // Increased from 125px
          },
          headerStyle: {
            padding: "0px 15px 0px 10px",
            minWidth: "140px",
          },
          render: (rowData) => (
            <Clamp lines={1}>
              {rowData.uwStatus ||
                (rowData.quoteSubmitted ? "Submitted" : "") ||
                rowData.step}
            </Clamp>
          ),
          customSort: (a, b) => {
            const statusOrder = {
              approved: 1,
              Bound: 2,
              Closed: 3,
              Declined: 4,
              onHold: 5,
              "Quote Generated": 6,
              Quoted: 7,
              rejected: 8,
              Submitted: 9,
              "Underwriting Page": 10,
              "UW Quest": 11,
            };
            const statusA =
              a.uwStatus || (a.quoteSubmitted ? "Submitted" : "") || a.step;
            const statusB =
              b.uwStatus || (b.quoteSubmitted ? "Submitted" : "") || b.step;
            const orderA = statusOrder[statusA] || 100;
            const orderB = statusOrder[statusB] || 100;
            return orderA - orderB;
          },
        },
        {
          title: "UW Comment",
          field: "uw_comments_download",
          filtering: true,
          filterPlaceholder: "Filter",
          render: (rowData) => {
            return (
              <div className="d-flex" style={{ width: "100%" }}>
                <textarea
                  value={
                    typeof rowData?.uw_comments?.[0] === "object"
                      ? rowData?.uw_comments?.[0]?.comment
                      : rowData?.uw_comments?.[0] || rowData?.uw_comments || ""
                  }
                  className="underwriter_comment"
                  rows="1"
                  disabled
                  style={{
                    width: "100%",
                    backgroundColor: setCommentBoxColor(rowData?.uw_comments),
                  }}
                ></textarea>
                <Tooltip title="Click to view comment history" arrow>
                  <button
                    className="comment-btn"
                    onClick={() =>
                      handleUwCommentHistory(
                        [rowData],
                        `${rowData?.user_email_id}`,
                      )
                    }
                  >
                    ...
                  </button>
                </Tooltip>
              </div>
            );
          },
          headerStyle: {
            padding: "0px 0px 0px 21px",
            minWidth: "260px", // Increased from 240px
          },
          filterCellStyle: {
            padding: "5px 5px 5px 14px",
          },
          cellStyle: {
            padding: "2px 9px 2px 6px",
            minWidth: "260px",
            width: "auto",
          },
        },
        {
          title: "Comments",
          field: "agent_comments_download",
          filtering: true,
          filterPlaceholder: "Filter",
          headerStyle: {
            padding: "0px 10px 0px 21px",
            minWidth: "260px", // Increased from 240px
          },
          filterCellStyle: {
            padding: "5px 5px 5px 14px",
          },
          cellStyle: {
            padding: "2px 10px 2px 6px",
            minWidth: "260px",
            width: "auto",
          },
          render: (rowData) => {
            const callbackFunction = (data) => {
              console.log("inside callback", data);
              console.log(rowData);
              this.updateData(data);
              this.updateDataInUser(data);
            };
            return (
              <div className="d-flex" style={{ width: "100%" }}>
                <TextField
                  key={`${rowData?.user_email_id}_comment`}
                  value={
                    typeof agentCommentsHistory[rowData?.user_email_id]?.[0] ===
                    "object"
                      ? agentCommentsHistory[rowData?.user_email_id]?.[0]
                          ?.comment
                      : agentCommentsHistory[rowData?.user_email_id]?.[0]
                  }
                  callback={callbackFunction}
                  rowData={rowData}
                  agentCommentsHistory={
                    agentCommentsHistory[rowData?.user_email_id]
                  }
                  handleAgentCommentHistory={this.handleAgentCommentHistory}
                  comments={agentCommentsHistory[rowData?.user_email_id]}
                  user={user}
                />
                <Tooltip title="Click to view comment history" arrow>
                  <button
                    className="comment-btn"
                    onClick={() =>
                      handleAgentCommentsButtonClick(
                        agentCommentsHistory[rowData?.user_email_id],
                        rowData?.uploadTimestamp,
                      )
                    }
                  >
                    ...
                  </button>
                </Tooltip>
              </div>
            );
          },
        },
        {
          title: "Modified Date",
          field: "uploadTimestamp",
          filtering: true,
          filterPlaceholder: "Filter",
          render: (rowData) => rowData.uploadTimestamp,
          customSort: (a, b) => this.dateSort(a, b, "uploadTimestamp"),
          headerStyle: {
            padding: "0px 0px 0px 8px",
            minWidth: "130px", // Increased from 120px
            textAlign: "center",
          },
          cellStyle: {
            padding: "2px 0px 2px 6px",
            minWidth: "130px",
            width: "auto",
            textAlign: "center",
          },
          customFilterAndSearch: (term, rowData, field) =>
            this.customFilterAll(term, rowData, field),
        },
        {
          title: "Download",
          sorting: false,
          disableSortBy: true,
          cellStyle: {
            padding: "2px 0px 2px 6px",
            minWidth: "80px", // Increased from 55px
            textAlign: "center",
          },
          headerStyle: {
            textAlign: "center",
            padding: "6px 2px 4px 14px",
            minWidth: "80px",
          },
          render: (rowData) => {
            let title = "";
            if (rowData?.fileList?.length) {
              for (let file of rowData?.fileList) {
                let fileToDisplay = file?.split("/");
                title =
                  title + fileToDisplay[fileToDisplay.length - 1] + " &#013; ";
              }
            }
            return (
              <button
                className="btn pt-0"
                type="button"
                title={parse(title)}
                data-html="true"
                onClick={() => {
                  console.log(rowData);
                  this.setModalData({
                    showModel: true,
                    modalTitle: <h1>{"Download"}</h1>,
                    modalContent: (
                      <>
                        <DownloadDashboardFiles
                          fileListToStore={rowData?.fileList}
                          summaryData={rowData?.lossSummaryData?.data?.key}
                          companyName={rowData?.companyName}
                        />
                      </>
                    ),
                  });
                }}
              >
                <img
                  src={
                    require("../../images/file-download-circle-green.svg")
                      .default
                  }
                  alt=""
                  style={
                    rowData.fileList.length
                      ? {
                          width: "30px",
                          filter: "grayscale(0)",
                        }
                      : {
                          width: "30px",
                          filter: "grayscale(100%) opacity(0.4)",
                        }
                  }
                />
              </button>
            );
          },
        },
      ],
    };

    // Add Salesforce column if user has permission
    if (loggedInGroups.includes(process.env.REACT_APP_SF_SYNC_GROUP)) {
      columns.tab1.push({
        title: "Salesforce",
        sorting: false,
        field: "salesforce",
        cellStyle: {
          padding: "2px 6px 2px 6px",
          minWidth: "100px", // Increased from 70px
          textAlign: "center",
        },
        headerStyle: {
          padding: "6px 2px 4px 14px",
          minWidth: "100px",
          textAlign: "center",
        },
        render: (rowData) => {
          return (
            <button
              className="btn btn-sm btn-warning"
              disabled={!rowData?.salesforceData}
              onClick={(e) => {
                this.updatePopUpData({
                  show: true,
                  title: "",
                  children: (
                    <>
                      <br></br>
                      <span style={{ fontWeight: "bold" }}>
                        This action will sync the prospect back to SF. Do you
                        want to Proceed?
                      </span>
                    </>
                  ),
                  acceptBtn: "Yes",
                  acceptBtnCallback: async () => {
                    try {
                      this.sendToSalesforce(rowData);
                    } catch (error) {
                      console.log("error: ", error);
                    }
                  },
                });
              }}
            >
              Sync
            </button>
          );
        },
      });
    }

    return (
      <div style={{ position: "relative", width: "100%" }}>
        <MaterialTable
          isLoading={isLoading}
          icons={tableIcons}
          data={rowDataList}
          columns={columns[tabName]}
          localization={{
            toolbar: {
              exportTitle: "Export the dashboard data",
            },
          }}
          detailPanel={[
            {
              tooltip: "Status info",
              icon: () => <KeyboardArrowRightIcon />,
              render: (rowData) => {
                return (
                  <div style={{ padding: "25px", width: "40%" }}>
                    <TableContainer component={Paper} style={{ width: "100%" }}>
                      <Table size="small" style={{ width: "100%" }}>
                        <TableHead
                          style={{
                            background: "#00000066",
                            color: "whitesmoke",
                          }}
                        >
                          <TableRow>
                            <TableCell>Status</TableCell>
                            <TableCell>Date</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {Object.values(rowData.status_info_rows).map(
                            (element, index) => {
                              return (
                                <TableRow key={index}>
                                  <TableCell scope="row">
                                    {element.status}
                                  </TableCell>
                                  <TableCell scope="row">
                                    {element.timestamp}
                                  </TableCell>
                                </TableRow>
                              );
                            },
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </div>
                );
              },
            },
          ]}
          options={{
            filtering: !this.state.dataLoading,
            filter: !this.state.dataLoading,
            paginationPosition: "both",
            padding: "dense",
            showTitle: false,
            thirdSortClick: false,
            pageSize: 10,
            pageSizeOptions: [
              25,
              50,
              75,
              100,
              500,
              1000,
              rowDataList?.length ? rowDataList.length : 0,
            ],
            exportFileName: "GetQuote Dashborad File",
            exportButton: {
              csv: true,
              pdf: false,
            },
            headerStyle: {
              fontSize: ismobile_font ? this.fontfunciton() : "1rem",
              backgroundColor: "#003764",
              color: "#FFF",
              padding: "6px 15px 6px 10px",
              fontFamily: "Montserrat",
              whiteSpace: "nowrap",
            },
            rowStyle: {
              fontSize: ismobile_font ? this.fontfunciton() : "0.95rem",
              color: "#000",
              fontFamily: "Montserrat",
            },
            searchFieldStyle: {
              fontSize: "0.95rem",
            },
            filterCellStyle: {
              padding: "5px 0px 5px 4px",
              fontFamily: "Montserrat",
            },
            // Add these options to improve table layout
            tableLayout: "auto",
            minBodyHeight: "500px",
            maxBodyHeight: "calc(100vh - 250px)",
            columnsButton: false,
            draggable: false,
            emptyRowsWhenPaging: false,
          }}
          components={{
            Pagination: (props) => (
              <TablePagination
                {...props}
                labelRowsPerPage={<div style={{ fontSize: 12 }}>{""}</div>}
                labelDisplayedRows={(row) => (
                  <div style={{ fontSize: 12 }}>{""}</div>
                )}
                SelectProps={{
                  style: {
                    fontSize: 12,
                  },
                }}
              />
            ),
          }}
        />
      </div>
    );
  };

  // Add this helper method to calculate total columns width
  calculateTotalColumns = () => {
    // This is just for reference, not actually used
    const columnWidths = {
      companyName: 220,
      fein: 110,
      govCCState: 130,
      govClassCode: 130,
      payroll: 140,
      effectiveDate: 130,
      distributingPartners: 200,
      modifiedBy: 140,
      status: 140,
      uwComment: 260,
      comments: 260,
      modifiedDate: 130,
      download: 80,
      salesforce: 100,
    };

    // Sum up all column widths to ensure they fill the container
    const totalWidth = Object.values(columnWidths).reduce((a, b) => a + b, 0);
    console.log("Total minimum table width:", totalWidth);
    return totalWidth;
  };

  formatPayrollToNumber = (payroll) => {
    // Remove '$' and ',' and convert to number
    return payroll ? parseFloat(payroll.replace(/[^\d.-]/g, "")) : 0;
  };

  updateDisplay = async () => {
    let sessionData = this.props.user;

    const makeNameReadable = (str) => {
      let _str = "";
      if (str) {
        _str = str
          .split("_")
          .map((e) => {
            return e[0].toUpperCase() + e.substr(1);
          })
          .join(" ");
      }
      return _str;
    };

    if (sessionData) {
      let loggedInGroups = this.props.allowedGroups;
      // sessionData?.signInUserSession?.accessToken?.payload?.[
      //   "cognito:groups"
      // ];

      if (loggedInGroups) {
        this.setState({ loggedInGroups });
      }

      let userType = sessionData.attributes["custom:user_type"];
      console.log("userType: ", userType);
      let req_body = {
        first_time_loading: "true",
      };
      let rowDataList = [];
      let _submissionYesNoList = {};
      let _agentCommentsHistory = {};
      let last_key;

      if (userType === "peo") {
        let email = sessionData.attributes.email;
        let user_peo = email.split("@")[0];
        req_body[userType] =
          user_peo === "jgregory"
            ? "gregory"
            : user_peo === "galactichr"
              ? "galactic"
              : user_peo;
      }

      await new Promise((resolve, reject) => {
        axios
          .post(awsUrl2 + "/api/userTableData/getAll", req_body)
          .then((res) => {
            let userDataList = [];
            let rowData;
            let step;

            let emailToNameMap = {
              "akshay@mobiux.in": "Akshay",
            };

            userDataList = res.data.list;
            last_key = res.data.old_key;

            // console.log(userDataList, "++++++++++++++++++++++++++++");
            for (let userDataRow in userDataList) {
              let userData = userDataList[userDataRow];
              let sortKeyPrepare = [];
              try {
                if (
                  userData?.isLossRunsAvailable &&
                  !userData?.lossRunDocumentUploaded
                ) {
                  step = "Quote Generated";
                } else if (
                  userData?.isLossRunsAvailable &&
                  (userData?.lossRunDocumentUploaded ||
                    userData?.summaryData?.status !== "DOC_COMPLETE")
                ) {
                  step = "Claims Processing";
                } else if (userData.status === "quote_generated") {
                  step = "Quote Generated";
                } else if (userData.status === "company_profile") {
                  step = "Underwriting Page";
                } else {
                  step = "-";
                }

                // Calculating total Payroll

                let payroll = 0;
                let classcodeInfo;
                let sum = 0;

                let childloc = userData.childrenLoc;
                // console.log(userData)

                for (let userDataRow in childloc) {
                  let userChildlocData = childloc[userDataRow];
                  // console.log(userChildlocData);
                  classcodeInfo = userChildlocData.classCodesInfo;
                  classcodeInfo = Object.entries(classcodeInfo);
                  // console.log(classcodeInfo)
                  for (let i = 0; i < classcodeInfo.length; i++) {
                    let paydata = classcodeInfo[i];
                    const stringAmount = paydata[1]?.payroll?.value;
                    if (!stringAmount) continue;
                    const numberAmount = parseFloat(
                      stringAmount.replace(/[^\d.-]/g, ""),
                    );
                    sum = sum + numberAmount;
                  }
                  // console.log(payroll)
                }

                payroll = sum;

                let modifiedBy;

                if (
                  userData.modifiedBy &&
                  userData.modifiedBy in emailToNameMap
                ) {
                  modifiedBy =
                    emailToNameMap[userData.modifiedBy.trim().toLowerCase()];
                } else {
                  modifiedBy = userData?.modifiedByName || userData.modifiedBy;
                }

                for (let key of userData?.address || []) {
                  sortKeyPrepare.push(
                    `${userData?.quoteData?.date}@${userData?.quoteData?.uuid}_${userData?.peoDetails?.selectedPeo}+${key}`,
                  );
                }

                //  Process to get Governing class code.

                let governingClassCode;
                let govClassCode = [];
                let maxPayroll = -Infinity;
                let govccstate;
                const childrenLoc = userData.childrenLoc;

                // Loop through each location
                if (childrenLoc) {
                  Object.values(childrenLoc).map((location) => {
                    // Check if classCodesInfo property exists and has values
                    if (location.classCodesInfo) {
                      // Loop through classCodesInfo to get payroll details
                      Object.values(location.classCodesInfo).map(
                        (classCode) => {
                          if (classCode) {
                            let classCodeobj = {
                              payroll: this.formatPayrollToNumber(
                                classCode.payroll.value,
                              ),
                              classCode:
                                classCode.classCodeDescription?.value?.split(
                                  ":",
                                )[0],
                              govccstate: location.state,
                            };
                            govClassCode.push(classCodeobj);
                          }
                        },
                      );
                    }
                  });
                }
                govClassCode.forEach((item) => {
                  if (item.payroll > maxPayroll) {
                    maxPayroll = item.payroll;
                    governingClassCode = item.classCode;
                    govccstate = item.govccstate.value;
                  }
                });

                let displayPeoName = this.selectedPeoFormat(
                  userData?.peoDetails?.selectedPeo,
                );
                let selectedPeoToDisplay;

                if (displayPeoName.toLowerCase() === "gms") {
                  selectedPeoToDisplay = "PEO1";
                } else if (displayPeoName.toLowerCase() === "tee off temps") {
                  selectedPeoToDisplay = "PEO2";
                } else {
                  selectedPeoToDisplay = displayPeoName;
                }

                rowData = {
                  step,
                  questcoId: userData?.questco_submission_id || "",
                  submittedDate: userData.status_info?.submit_to_underwriter
                    ?.timestamp
                    ? moment(
                        userData.status_info?.submit_to_underwriter?.timestamp,
                        "x",
                      ).format("M/D/YY")
                    : "-",
                  createdDate: userData.createdDate
                    ? moment(userData.createdDate, "x").format("M/D/YY")
                    : "-",
                  uploadTimestamp: userData.uploadTimestamp
                    ? moment(userData.uploadTimestamp, "x").format("M/D/YY")
                    : "-",
                  effectiveDate: userData?.companyProfile?.effectiveDate?.value
                    ? moment(
                        userData?.companyProfile?.effectiveDate?.value,
                      ).format("M/D/YY")
                    : "-",
                  phoneNumber: userData?.companyProfile?.phoneNumber?.value,
                  contactName:
                    this.camelCase(userData?.companyProfile?.firstName?.value) +
                    " " +
                    this.camelCase(userData?.companyProfile?.lastName?.value),
                  companyName:
                    userData?.companyProfile?.companyName?.value || "-",
                  peo: userData?.companyProfile?.peo?.value || "-",
                  fein: userData?.companyProfile?.fein?.value,
                  modifiedBy: modifiedBy || "-",
                  childrenLoc: userData?.childrenLoc,
                  payroll: payroll?.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                    minimumFractionDigits: 0,
                  }),
                  companyProfile: userData?.companyProfile,
                  state:
                    userData?.companyProfile?.state1?.value?.toUpperCase() ||
                    "-",
                  emodStatesData: userData?.emodStatesData,
                  uw_ques: userData?.uw_ques,
                  user_email_id: userData?.user_email_id,
                  status: userData?.status,
                  quoteData: userData?.quoteData,
                  address: userData?.address,
                  status: userData?.status,
                  riskProfile: userData?.riskProfile,
                  riskProfileId: userData?.riskProfileId,
                  targetPremium: userData?.targetPremium,
                  peoDetails: userData?.peoDetails,
                  carrierList: userData?.carrierList,
                  amtrustAccountDetails: userData?.amtrustAccountDetails,
                  amtrustAccountDetailsCopy:
                    userData?.amtrustAccountDetailsCopy,
                  quoteSubmitted: userData?.quoteSubmitted,
                  uw_comments: userData?.uw_comments
                    ? typeof userData?.uw_comments === "string"
                      ? [userData?.uw_comments]
                      : userData?.uw_comments
                    : [""],
                  agent_comments: userData?.agent_comments
                    ? typeof userData.agent_comments === "string"
                      ? [userData?.agent_comments]
                      : userData?.agent_comments
                    : [""],
                  uwStatus: userData?.uw_status,
                  uuidCarriers: sortKeyPrepare,
                  govClassCode: governingClassCode,
                  govCCState: govccstate,
                  selectedPeo: userData?.peoDetails?.selectedPeo,
                  salesforceData: userData?.salesforceData,
                  fileList: userData?.fileList ? userData?.fileList : [],
                  selectedPeoToDisplay: selectedPeoToDisplay,
                  real_submission: userData.real_submission || "false",
                  status_info_rows: [],
                  agency: userData?.agency || "-",
                  historicalClaims: userData?.historicalClaims || {},
                  lossSummaryData: userData?.summaryData || {},
                  lossRunUploaded: userData?.isLossRunsAvailable || false,
                };

                let _status_info = userData?.status_info || {};

                try {
                  for (let status in _status_info) {
                    if (status === "underwriting_page_status") {
                      for (let carr in _status_info[status]) {
                        for (let sts in _status_info[status][carr]) {
                          rowData.status_info_rows.push({
                            status:
                              makeNameReadable(sts) +
                              " (with carrier: " +
                              (carrierMapping[carr] || carr) +
                              ")",
                            timestamp: moment(
                              _status_info[status][carr][sts].timestamp,
                              "x",
                            ).format("MM/DD/YYYY HH:mm:ss"),
                          });
                        }
                      }
                    } else {
                      rowData.status_info_rows.push({
                        status: makeNameReadable(status),
                        timestamp: moment(
                          _status_info[status].timestamp,
                          "x",
                        ).format("MM/DD/YYYY HH:mm:ss"),
                      });
                    }
                  }
                } catch (error) {
                  console.log(error);
                }

                rowData.status_info_rows.sort((a, b) =>
                  a.timestamp < b.timestamp
                    ? 1
                    : a.timestamp > b.timestamp
                      ? -1
                      : 0,
                );

                createCommentForDownload(rowData, "uw_comments");
                createCommentForDownload(rowData, "agent_comments");

                _submissionYesNoList[rowData.user_email_id] =
                  userData.real_submission === "true" ? true : false;

                createSubmissionForDownload(rowData, "real_submission");

                _agentCommentsHistory[rowData.user_email_id] =
                  userData?.agent_comments
                    ? typeof userData.agent_comments === "string"
                      ? [userData?.agent_comments]
                      : userData?.agent_comments
                    : [""];
                if (rowData.companyName === "-") continue;
                rowDataList.push(rowData);
              } catch (error) {
                console.log("error in: ", userData, error);
              }
            }

            this.setState((prevstate) => {
              let submissionYesNoList = JSON.parse(
                JSON.stringify(prevstate.submissionYesNoList),
              );
              let agentCommentsHistory = JSON.parse(
                JSON.stringify(prevstate.agentCommentsHistory),
              );
              return {
                rowDataList,
                isLoading: false,
                submissionYesNoList: {
                  ..._submissionYesNoList,
                  ...submissionYesNoList,
                },
                agentCommentsHistory: {
                  ..._agentCommentsHistory,
                  ...agentCommentsHistory,
                },
              };
            });
            resolve();
          })
          .catch((error) => {
            console.log("error", error);
            reject();
          });
      });

      do {
        if (last_key) {
          req_body["lastEvaluatedKey"] = last_key;
        }

        delete req_body["first_time_loading"];

        await new Promise((resolve, reject) => {
          axios
            .post(awsUrl2 + "/api/userTableData/getAll", req_body)
            .then((res) => {
              console.log("res: ", res);
              let userDataList = [];
              let rowData;
              let step;

              let emailToNameMap = {
                "akshay@mobiux.in": "Akshay",
              };

              userDataList = res.data.list;
              last_key = res.data.old_key;

              // console.log(userDataList, "++++++++++++++++++++++++++++");

              for (let userDataRow in userDataList) {
                let userData = userDataList[userDataRow];
                let sortKeyPrepare = [];
                try {
                  if (
                    userData?.isLossRunsAvailable &&
                    !userData?.lossRunDocumentUploaded
                  ) {
                    step = "Quote Generated";
                  } else if (
                    userData?.isLossRunsAvailable &&
                    (userData?.lossRunDocumentUploaded ||
                      userData?.summaryData?.status !== "DOC_COMPLETE")
                  ) {
                    step = "Claims Processing";
                  } else if (userData.status === "quote_generated") {
                    step = "Quote Generated";
                  } else if (userData.status === "company_profile") {
                    step = "Underwriting Page";
                  } else {
                    step = "-";
                  }

                  // Calculating total Payroll

                  let payroll = 0;
                  let classcodeInfo;
                  let sum = 0;

                  let childloc = userData.childrenLoc;

                  for (let userDataRow in childloc) {
                    let userChildlocData = childloc[userDataRow];
                    // console.log(userChildlocData);
                    classcodeInfo = userChildlocData.classCodesInfo;
                    classcodeInfo = Object.entries(classcodeInfo);
                    // console.log(classcodeInfo)
                    for (let i = 0; i < classcodeInfo.length; i++) {
                      let paydata = classcodeInfo[i];
                      const stringAmount = paydata[1]?.payroll?.value;
                      if (!stringAmount) continue;
                      const numberAmount = parseFloat(
                        stringAmount.replace(/[^\d.-]/g, ""),
                      );
                      sum = sum + numberAmount;
                    }
                    // console.log(payroll)
                  }
                  payroll = sum;

                  let modifiedBy;

                  if (
                    userData.modifiedBy &&
                    userData.modifiedBy in emailToNameMap
                  ) {
                    modifiedBy =
                      emailToNameMap[userData.modifiedBy.trim().toLowerCase()];
                  } else {
                    modifiedBy =
                      userData?.modifiedByName || userData.modifiedBy
                        ? userData.modifiedBy.split("@")[0].length <= 3
                          ? userData.modifiedBy.split("@")[0].toUpperCase()
                          : userData.modifiedBy.split("@")[0][0].toUpperCase() +
                            userData.modifiedBy.split("@")[0].slice(1)
                        : "";
                  }

                  for (let key of userData?.address || []) {
                    sortKeyPrepare.push(
                      `${userData?.quoteData?.date}@${userData?.quoteData?.uuid}_${userData?.peoDetails?.selectedPeo}+${key}`,
                    );
                  }

                  // Calculating Highest payroll and finding Governing class code

                  let governingClassCode;
                  let govClassCode = [];
                  let maxPayroll = -Infinity;
                  let govccstate;
                  const childrenLoc = userData.childrenLoc;

                  if (childrenLoc) {
                    Object.values(childrenLoc).map((location) => {
                      // Check if classCodesInfo property exists and has values
                      if (location.classCodesInfo) {
                        // Loop through classCodesInfo to get payroll details
                        Object.values(location.classCodesInfo).map(
                          (classCode) => {
                            if (classCode) {
                              let classCodeobj = {
                                payroll: this.formatPayrollToNumber(
                                  classCode.payroll.value,
                                ),
                                classCode:
                                  classCode.classCodeDescription?.value?.split(
                                    ":",
                                  )[0],
                                govccstate: location.state,
                              };
                              govClassCode.push(classCodeobj);
                            }
                          },
                        );
                      }
                    });
                  }
                  govClassCode.forEach((item) => {
                    if (item.payroll > maxPayroll) {
                      maxPayroll = item.payroll;
                      governingClassCode = item.classCode;
                      govccstate = item.govccstate.value;
                    }
                  });

                  let displayPeoName = this.selectedPeoFormat(
                    userData?.peoDetails?.selectedPeo,
                  );
                  let selectedPeoToDisplay;

                  if (displayPeoName.toLowerCase() === "gms") {
                    selectedPeoToDisplay = "PEO1";
                  } else if (displayPeoName.toLowerCase() === "tee off temps") {
                    selectedPeoToDisplay = "PEO2";
                  } else {
                    selectedPeoToDisplay = displayPeoName;
                  }

                  rowData = {
                    step,
                    submittedDate: userData.status_info?.submit_to_underwriter
                      ?.timestamp
                      ? moment(
                          userData.status_info?.submit_to_underwriter
                            ?.timestamp,
                          "x",
                        ).format("M/D/YY")
                      : "-",
                    createdDate: userData.createdDate
                      ? moment(userData.createdDate, "x").format("M/D/YY")
                      : "-",
                    uploadTimestamp: userData.uploadTimestamp
                      ? moment(userData.uploadTimestamp, "x").format("M/D/YY")
                      : "-",
                    effectiveDate: userData?.companyProfile?.effectiveDate
                      ?.value
                      ? moment(
                          userData?.companyProfile?.effectiveDate?.value,
                        ).format("M/D/YY")
                      : "-",
                    phoneNumber: userData?.companyProfile?.phoneNumber?.value,
                    contactName:
                      this.camelCase(
                        userData?.companyProfile?.firstName?.value,
                      ) +
                      " " +
                      this.camelCase(userData?.companyProfile?.lastName?.value),
                    companyName:
                      userData?.companyProfile?.companyName?.value || "-",
                    peo: userData?.companyProfile?.peo?.value || "-",
                    fein: userData?.companyProfile?.fein?.value,
                    modifiedBy: modifiedBy || "-",
                    childrenLoc: userData?.childrenLoc,
                    payroll: payroll?.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                      minimumFractionDigits: 0,
                    }),
                    companyProfile: userData?.companyProfile,
                    state:
                      userData?.companyProfile?.state1?.value?.toUpperCase() ||
                      "-",
                    emodStatesData: userData?.emodStatesData,
                    uw_ques: userData?.uw_ques,
                    user_email_id: userData?.user_email_id,
                    status: userData?.status,
                    quoteData: userData?.quoteData,
                    address: userData?.address,
                    status: userData?.status,
                    riskProfile: userData?.riskProfile,
                    riskProfileId: userData?.riskProfileId,
                    targetPremium: userData?.targetPremium,
                    peoDetails: userData?.peoDetails,
                    carrierList: userData?.carrierList,
                    amtrustAccountDetails: userData?.amtrustAccountDetails,
                    quoteSubmitted: userData?.quoteSubmitted,
                    uw_comments: userData?.uw_comments
                      ? typeof userData?.uw_comments === "string"
                        ? [userData?.uw_comments]
                        : userData?.uw_comments
                      : [""],
                    agent_comments: userData?.agent_comments
                      ? typeof userData.agent_comments === "string"
                        ? [userData?.agent_comments]
                        : userData?.agent_comments
                      : [""],
                    uwStatus: userData?.uw_status,
                    uuidCarriers: sortKeyPrepare,
                    govClassCode: governingClassCode,
                    govCCState: govccstate,
                    selectedPeo: userData?.peoDetails?.selectedPeo,
                    selectedPeoToDisplay: selectedPeoToDisplay,
                    fileList: userData?.fileList ? userData?.fileList : [],
                    real_submission: userData.real_submission || "false",
                    status_info_rows: [],
                    lossSummaryData: userData?.summaryData || {},
                    lossRunUploaded: userData?.isLossRunsAvailable || false,
                  };

                  let _status_info = userData?.status_info || {};

                  try {
                    for (let status in _status_info) {
                      if (status === "underwriting_page_status") {
                        for (let carr in _status_info[status]) {
                          for (let sts in _status_info[status][carr]) {
                            rowData.status_info_rows.push({
                              status:
                                makeNameReadable(sts) +
                                " (with carrier: " +
                                (carrierMapping[carr] || carr) +
                                ")",
                              timestamp: moment(
                                _status_info[status][carr][sts].timestamp,
                                "x",
                              ).format("MM/DD/YYYY HH:mm:ss"),
                            });
                          }
                        }
                      } else {
                        rowData.status_info_rows.push({
                          status: makeNameReadable(status),
                          timestamp: moment(
                            _status_info[status].timestamp,
                            "x",
                          ).format("MM/DD/YYYY HH:mm:ss"),
                        });
                      }
                    }
                  } catch (error) {
                    console.log(error);
                  }

                  rowData.status_info_rows.sort((a, b) =>
                    a.timestamp < b.timestamp
                      ? 1
                      : a.timestamp > b.timestamp
                        ? -1
                        : 0,
                  );

                  createCommentForDownload(rowData, "uw_comments");
                  createCommentForDownload(rowData, "agent_comments");

                  _submissionYesNoList[rowData.user_email_id] =
                    userData.real_submission === "true" ? true : false;

                  createSubmissionForDownload(rowData, "real_submission");
                  _agentCommentsHistory[rowData.user_email_id] =
                    userData?.agent_comments
                      ? typeof userData.agent_comments === "string"
                        ? [userData?.agent_comments]
                        : userData?.agent_comments
                      : [""];
                  if (rowData.companyName === "-") continue;
                  rowDataList.push(rowData);
                } catch (error) {
                  console.log("error in: ", userData, error);
                }
              }

              this.setState((prevstate) => {
                let submissionYesNoList = JSON.parse(
                  JSON.stringify(prevstate.submissionYesNoList),
                );
                let agentCommentsHistory = JSON.parse(
                  JSON.stringify(prevstate.agentCommentsHistory),
                );
                return {
                  rowDataList,
                  isLoading: false,
                  submissionYesNoList: {
                    ..._submissionYesNoList,
                    ...submissionYesNoList,
                  },
                  agentCommentsHistory: {
                    ..._agentCommentsHistory,
                    ...agentCommentsHistory,
                  },
                };
              });
              resolve();
            })
            .catch((error) => {
              console.log("error", error);
              reject();
            });
        });
      } while (last_key);

      if (!last_key) {
        this.setState({ dataLoading: false });
      }
    }
  };

  updatePopUpData = (popupData) => {
    this.setState({ popupData });
  };

  toastSuccess = (text) =>
    toast.success(text, {
      duration: 3000,
    });

  toastError = (text) =>
    toast.error(text, {
      duration: 3000,
    });

  getSalesforcePayrollInfo = (childrenloc) => {
    let payrollInfo = [];
    let totalPayroll = 0;
    try {
      for (let locationIndex in childrenloc) {
        let state = childrenloc[locationIndex].state.value;
        for (let classCodeIndex in childrenloc[locationIndex].classCodesInfo) {
          let { classCodeDescription, payroll } =
            childrenloc[locationIndex].classCodesInfo[classCodeIndex];
          let splitArray = classCodeDescription.value.split(":");

          let classCode = splitArray[0];
          let description = splitArray.slice(1).join(":").trim();

          payroll = numeral(payroll.value).value();
          totalPayroll += payroll;

          payrollInfo.push({
            classCode,
            description,
            state,
            payroll: String(payroll),
          });
        }
      }
    } catch (error) {
      console.log(error);
      payrollInfo = [];
      totalPayroll = 0;
    }

    return { payrollInfo, totalPayroll: String(totalPayroll) };
  };
  populateUserTableWithFileList = async (populateFlag) => {
    const fileList = [];
    const uwFileList = [];
    if (!populateFlag) {
      try {
        axios
          .post(awsUrl + "/api/underWriterData/getAll", {})
          .then(async (res) => {
            let dataFromAPI = res.data;
            for (let item in dataFromAPI)
              for (let item_item in dataFromAPI[item]) {
                if (
                  dataFromAPI[item][item_item]?.["fileList"] ||
                  dataFromAPI[item][item_item]?.["uwFileList"]
                ) {
                  for (let fileIndex in dataFromAPI[item][item_item]?.[
                    "fileList"
                  ]) {
                    if (
                      !fileList.includes(
                        dataFromAPI[item][item_item]["fileList"][fileIndex][
                          "key"
                        ],
                      )
                    )
                      fileList.push(
                        dataFromAPI[item][item_item]["fileList"][fileIndex][
                          "key"
                        ],
                      );
                  }
                  for (let fileIndex in dataFromAPI[item][item_item]?.[
                    "uwFileList"
                  ]) {
                    if (
                      !uwFileList.includes(
                        dataFromAPI[item][item_item]["uwFileList"][fileIndex][
                          "key"
                        ],
                      )
                    )
                      uwFileList.push(
                        dataFromAPI[item][item_item]["uwFileList"][fileIndex][
                          "key"
                        ],
                      );
                  }
                }
              }
            const fileListCopy = {};
            fileList.forEach((item) => {
              const key = item.split("/")[0];
              if (Object.keys(fileListCopy).includes(key))
                fileListCopy[key].push(item);
              else {
                fileListCopy[key] = [];
                fileListCopy[key].push(item);
              }
            });
            uwFileList.forEach((item) => {
              const key = item.split("/")[0];
              if (Object.keys(fileListCopy).includes(key))
                fileListCopy[key].push(item);
              else {
                fileListCopy[key] = [];
                fileListCopy[key].push(item);
              }
            });
            for (let item in fileListCopy) {
              const userFileDetail = {
                user_email_id: item,
                fileList: fileListCopy[item],
              };
              await axios
                .post(awsUrl2 + "/api/userTableData/update", userFileDetail)
                .then((res2) => {})
                .catch((err) => {
                  console.log("Error:", err);
                });
              console.log("inserted successfully");
              // break;
            }
          });
      } catch (err) {
        console.log(err);
      }
      this.setState({ populateFlag: true });
    }
  };

  sendToSalesforce = async (rowData) => {
    try {
      let {
        companyName,
        descriptionOfOperations,
        entityType,
        fein,
        phoneNumber,
        yearsInBusiness,
        effectiveDate,
        street1,
        street2,
        cityName1,
        cityName2,
        state1,
        state2,
        zipCode1,
        zipCode2,
      } = rowData?.companyProfile || {};

      let { accountId, opportunityId } = rowData?.salesforceData || {};

      let { payrollInfo, totalPayroll } = this.getSalesforcePayrollInfo(
        rowData?.childrenLoc,
      );

      let data = {
        companyName: companyName?.value?.trim() || "",
        description: descriptionOfOperations?.value?.trim() || "",
        entityType: entityType?.value?.trim() || "",
        fein: fein?.value?.trim() || "",
        phoneNumber: phoneNumber?.value?.trim() || "",
        yearsInBusiness: yearsInBusiness?.value?.trim() || "",
        opportunityId,
        accountId,
        totalPayroll,
        effectiveDate: moment
          .utc(effectiveDate.value)
          .local()
          .format("M/D/YYYY"),
        billingStreet: street2?.value?.trim(),
        billingCity: cityName2?.value?.trim(),
        billingState: state2?.value?.trim()?.toUpperCase(),
        billingPostalCode: zipCode2?.value?.trim(),
        billingCountry: "USA",
        shippingStreet: street1?.value?.trim(),
        shippingCity: cityName1?.value?.trim(),
        shippingState: state1?.value?.trim()?.toUpperCase(),
        shippingPostalCode: zipCode1?.value?.trim(),
        shippingCountry: "USA",
        payrollInfo,
      };
      console.log(data);

      let response = await axios.put(awsUrl2 + "/api/sendToSalesforce", data);
      console.log("++response", response);
      this.toastSuccess("Synced successfully");
    } catch (error) {
      console.log(error);
      this.toastError("Error while syncing");
    }
  };

  render() {
    let { openModal, modalBody, agentButton, handleCloseModal } = this.props;
    // !this.state.populateFlag && this.populateUserTableWithFileList();
    let { showModel, modalTitle, modalContent } = this.state.modalData;
    return (
      <div>
        {this.state.dataLoading ? (
          <div style={{ marginLeft: "50%" }}>
            <RotatingLines
              visible={true}
              height="40"
              width="40"
              color="black"
              strokeColor="grey"
              strokeWidth="5"
              animationDuration="0.75"
              ariaLabel="rotating-lines-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
            <b>Data Loading.....</b>
          </div>
        ) : (
          <div style={{ marginLeft: "50%" }}></div>
        )}

        <div ref={this.myRef}>{this.setTableData()}</div>
        {agentButton ? (
          <Dialog open={openModal} onClose={handleCloseModal}>
            <DialogTitle>
              <p style={{ textAlign: "center" }}>
                {(modalBody.length > 0 &&
                  modalBody?.[0] !== "" &&
                  modalBody?.[0]?.comment !== "") ||
                modalBody?.[0]?.previousComment
                  ? "Comment History"
                  : "No Comment History"}
              </p>
              <IconButton
                aria-label="close"
                onClick={handleCloseModal}
                style={{ position: "absolute", right: "5px", top: "8px" }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              {modalBody.length > 0 &&
                modalBody[0] !== "" &&
                modalBody.map((item, index) => {
                  let date = moment(item.commentTimestamp)
                    .format("M/D/YY h:mm A")
                    .split(" ")[0];
                  let time = moment(item.commentTimestamp)
                    .format("M/D/YY h:mm A")
                    .split(" ")[1];
                  if (item.comment !== "") {
                    if (item.commentTimestamp || item.email || item) {
                      return (
                        <div>
                          <div>
                            <span>
                              <b>{date}</b>
                            </span>
                            <span
                              style={{
                                marginLeft: "10px",
                                marginRight: "10px",
                              }}
                            >
                              <b>{time}</b>
                            </span>
                            <span>{item.email ? "- " : ""}</span>
                            <span>
                              <b>{item.email?.split("@")[0]}</b>
                            </span>
                          </div>
                          <div>
                            <p>
                              {item?.comment
                                ? item.comment
                                : modalBody[index + 1]?.comment
                                  ? modalBody[index + 1].comment
                                  : item}
                            </p>
                          </div>
                          <br />
                        </div>
                      );
                    }
                  } else {
                    return;
                  }
                })}
            </DialogContent>
          </Dialog>
        ) : (
          <Dialog open={openModal} onClose={handleCloseModal}>
            <DialogTitle>
              <p style={{ textAlign: "center" }}>
                {(modalBody.length > 0 &&
                  modalBody?.[0] !== "" &&
                  modalBody?.[0]?.comment !== "") ||
                modalBody?.[0]?.previousComment
                  ? "Comment History"
                  : "No Comment History"}
              </p>
              <IconButton
                aria-label="close"
                onClick={handleCloseModal}
                style={{ position: "absolute", right: "5px", top: "8px" }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              {modalBody.length > 0 &&
                modalBody[0] !== "" &&
                modalBody.map((item, index) => {
                  let date = moment(item.commentTimestamp)
                    .format("M/D/YY h:mm A")
                    .split(" ")[0];
                  let time = moment(item.commentTimestamp)
                    .format("M/D/YY h:mm A")
                    .split(" ")[1];
                  if (item.comment !== "") {
                    if (item.commentTimestamp || item.email || item) {
                      return (
                        <div>
                          <div>
                            <span>
                              <b>{date}</b>
                            </span>
                            <span
                              style={{
                                marginLeft: "10px",
                                marginRight: "10px",
                              }}
                            >
                              <b>{time}</b>
                            </span>
                            <span>{item.email ? "- " : ""}</span>
                            <span>
                              <b>{item.email?.split("@")[0]}</b>
                            </span>
                          </div>
                          <div>
                            <p>
                              {item?.comment
                                ? item.comment
                                : modalBody[index + 1]?.comment
                                  ? modalBody[index + 1].comment
                                  : item}
                            </p>
                          </div>
                          <br />
                        </div>
                      );
                    }
                  } else {
                    return;
                  }
                })}
            </DialogContent>
          </Dialog>
        )}
        <Modal
          show={showModel}
          onHide={() => {
            this.setModalData({
              showModel: false,
              modalTitle: null,
              modalContent: null,
            });
          }}
          dialogClassName="model-download modal-dialog-centered"
        >
          <Modal.Header closeButton>
            <Modal.Title>{modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>{modalContent}</Modal.Body>
        </Modal>
        <Toaster />
        {this.state.popupData.show && (
          <Popup
            popupData={this.state.popupData}
            updatePopUpData={this.updatePopUpData}
          />
        )}
      </div>
    );
  }
}

export default DashboardLibertate;
